import {
  first, some, split, startsWith,
} from 'lodash/fp';

export const getLanguageFrom = (locale) => split(/[-_]/, locale)[0];


export const getMessageLocale = ({ locale, preserved } = {}) => (
  some((language) => startsWith(language, locale), preserved)
    ? locale : first(split(/[-_]/, locale))
);
